/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientDetailsResource } from './';
import {
    ClientDetailsResourceFromJSON,
    ClientDetailsResourceFromJSONTyped,
    ClientDetailsResourceToJSON,
} from './';
import type { ProjectDetailsResource } from './';
import {
    ProjectDetailsResourceFromJSON,
    ProjectDetailsResourceFromJSONTyped,
    ProjectDetailsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepatriationOpportunityBriefResource
 */
export interface RepatriationOpportunityBriefResource {
    /**
     * 
     * @type {ProjectDetailsResource}
     * @memberof RepatriationOpportunityBriefResource
     */
    projectDetails: ProjectDetailsResource;
    /**
     * 
     * @type {ClientDetailsResource}
     * @memberof RepatriationOpportunityBriefResource
     */
    clientDetails?: ClientDetailsResource;
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityBriefResource
     */
    clientCompanyName?: string;
}

/**
 * Check if a given object implements the RepatriationOpportunityBriefResource interface.
 */
export function instanceOfRepatriationOpportunityBriefResource(value: object): value is RepatriationOpportunityBriefResource {
    if (!('projectDetails' in value) || value['projectDetails'] === undefined) return false;
    return true;
}

export function RepatriationOpportunityBriefResourceFromJSON(json: any): RepatriationOpportunityBriefResource {
    return RepatriationOpportunityBriefResourceFromJSONTyped(json, false);
}

export function RepatriationOpportunityBriefResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityBriefResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectDetails': ProjectDetailsResourceFromJSON(json['projectDetails']),
        'clientDetails': json['clientDetails'] == null ? undefined : ClientDetailsResourceFromJSON(json['clientDetails']),
        'clientCompanyName': json['clientCompanyName'] == null ? undefined : json['clientCompanyName'],
    };
}

export function RepatriationOpportunityBriefResourceToJSON(value?: RepatriationOpportunityBriefResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectDetails': ProjectDetailsResourceToJSON(value['projectDetails']),
        'clientDetails': ClientDetailsResourceToJSON(value['clientDetails']),
        'clientCompanyName': value['clientCompanyName'],
    };
}

